import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "message"]

  declare readonly inputTarget: HTMLInputElement;
  declare readonly messageTarget: HTMLElement;

  validate() {
    const inputEl = this.inputTarget;
    const maxVal = Number(inputEl.getAttribute('max'));
    const currentValue = Number(inputEl.value);

    if (maxVal && currentValue > maxVal) {
      this.messageTarget.textContent = `The maximum allowed value is ${maxVal}.`;
    } else {
      this.messageTarget.textContent = '';
    }
  }

  increment(event: Event) {
    event.preventDefault()
    this.inputTarget.stepUp()
    this.validate()
    this.dispatchEvent()
  }

  decrement(event: Event) {
    event.preventDefault()
    this.inputTarget.stepDown()
    this.validate()
    this.dispatchEvent()
  }

  dispatchEvent() {
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
